import type { SoundEffectAsset } from '@/features/audio-form/data/dto/audio-form-input.ts'
import { TrackType, type TracksStore } from '@/shared/store/tracks.store.tsx'

export const mapSoundEffectClipsToAssets = (
  tracksStore: TracksStore
): Record<string, SoundEffectAsset> => {
  const assets: Record<string, SoundEffectAsset> = {}

  for (const { type, clips } of tracksStore.tracks) {
    if (type !== TrackType.SoundEffects) continue
    for (const { mediaId, duration, src } of clips) {
      assets[mediaId] = {
        type: 'soundEffect',
        soundEffectAlias: mediaId,
        duration,
        ...(src && { uri: src }),
      }
    }
  }
  return assets
}
